export default function () {
	return {
		theme: {
			extend: {
				colors: {
					green: {
						base: '#95BB49',
						'success-dark': '#138600',
						'success-light': '#92E583',
						'primary-tint-3': '#D5E4B6',
						'primary-shade-1': '#77963A',
					},
					blue: {
						base: '#01395E',
						tints: '#34617E',
						'tint-3': '#99B0BF',
						'tint-4': '#CCD7DF',
						link: '#67889E',
						visited: '#01395E',
						background: '#F1F5F8',
					},
					black: { neutral: '#272728', DEFAULT: '#000000', link: '#272728' },
					white: { DEFAULT: '#fff', neutral: '#FEFEFE' },
					red: { danger: '#C60020', 'danger-light': '#FFA9A9' },
					purple: { info: '#6745ED', 'info-light': '#C5CBF1' },
					yellow: { caution: '#FFE986', 'caution-medium': '#9B5400', 'caution-light': '#FFF2B6' },
					gray: { medium: '#737576', dark: '#464947', light: '#F1F1F1' },

					typoghaphyNeutralTone: {
						100: '#C0C7D1',
						200: '#EBECF0',
						300: '#FAFBFD',
						400: '#FFFFFF',
					},

					primary: {
						100: '#01395E',
						200: '#5E855F',
						300: '#95BB49',
						400: '#C6D401',
						500: '#4B4B4D',
						600: '#909193',
						700: '#E6E6E6',
						800: '#F9FAFB',
					},
				},
			},
		},
	}
}
